import { PlusIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Drink } from "src/lib/db";
import { useGetDrinkTypes } from "src/lib/hooks/useGetTypes";
import { DrinkCache } from "src/lib/slices/drinkCache";
import { Card, CardContent } from "../ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import UserAvatar from "../userAvatar";
import DrinkCard from "./DrinkCard";
import style from "./DrinkSelector.module.css";
import DrinkTabContent from "./DrinkTabContent";

export default function DrinkTabs({
  selection,
  open,
  setOpen,
  selectDrink,
  selectedDrink,
}) {
  const navigate = useNavigate();

  const drinkTypes = useGetDrinkTypes();

  const user = useSelector((state: any) => state.user);

  const [tabsValue, setTabsValue] = useState(selectedDrink?.type);

  const ownDrinks: Drink[] = useSelector((state: any) => state.ownItems.Drinks);

  const cachedDrinks: DrinkCache = useSelector(
    (state: any) => state.drinkCache
  );

  const recentDrinks = [
    ...cachedDrinks.drinks.filter((drink) => drink.lastUsedAt),
  ]
    .sort((a, b) => b.lastUsedAt - a.lastUsedAt)
    .map((cacheRecord) => cacheRecord.drink);

  return (
    <Tabs value={tabsValue} onValueChange={setTabsValue as any}>
      <TabsList
        className={`grid w-full rounded-md ${style.tabs}`}
        style={{
          backgroundColor: "hsl(var(--muted))",
          display: "flex",
          flexWrap: "wrap",
          rowGap: "0.25rem",
          height: "fit-content",
          top: 0,
        }}
      >
        <TabsTrigger value={"Recent"} key={"Recent"}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1ch",
            }}
          >
            <UserAvatar friend={user} className="h-4 w-4" /> Nedávné
          </div>
        </TabsTrigger>
        {drinkTypes.map((drinkType, index) => (
          <TabsTrigger value={drinkType.key} key={drinkType.key}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1ch",
              }}
            >
              <div
                style={{
                  width: "0.75rem",
                  height: "1rem",
                }}
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}/images/drink/${drinkType.icon}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                  alt=""
                />
              </div>
              <div>{drinkType.name}</div>
            </div>
          </TabsTrigger>
        ))}
        <TabsTrigger value={"Own"} key={"Own"}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1ch",
            }}
          >
            <UserAvatar friend={user} className="h-4 w-4" /> Vlastní
          </div>
        </TabsTrigger>
      </TabsList>
      <TabsContent
        value={"Recent"}
        key={"Recent"}
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(8rem, 1fr))",
          gridTemplateRows: "repeat(auto-fill, 1fr)",
          gap: "1rem",
        }}
        className="mt-4"
      >
        {recentDrinks.map((drink) => (
          <DrinkCard
            drink={drink}
            selection={selection}
            selectDrink={selectDrink}
            key={drink.id}
          />
        ))}
      </TabsContent>
      {drinkTypes.map((drinkType) => (
        <DrinkTabContent
          drinkType={drinkType}
          key={drinkType.key}
          selection={selection}
          selectDrink={selectDrink}
        />
      ))}
      <TabsContent
        value={"Own"}
        key={"Own"}
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(8rem, 1fr))",
          gridTemplateRows: "repeat(auto-fill, 1fr)",
          gap: "1rem",
        }}
        className="mt-4"
      >
        {ownDrinks.map((drink) => (
          <DrinkCard
            drink={drink}
            selection={selection}
            selectDrink={selectDrink}
            key={drink.id}
          />
        ))}
        <Card
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            cursor: "pointer",
            minHeight: "5rem",
          }}
          key={"Add"}
          onClick={() => {
            navigate("/own-drinks");
          }}
        >
          <CardContent
            style={{
              padding: "0.25rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <PlusIcon />
          </CardContent>
        </Card>
      </TabsContent>
    </Tabs>
  );
}
